const riot = require('riot');

riot.tag2('module-select-provider', '<div class="f fclm fm px24 pt24"> <div class="ts-hs text-gray_80 mb24">受け取るポイント種別</div> <div class="ts-ps text-gray_80 mb24">特典として受け取るポイントの種別を選択できます</div> <form class="w-full" ref="form" onsubmit="{submit}"> <label class="block cursor-pointer mb19" each="{provider in filteredProviders()}"> <div class="f fm"> <input class="radio mr16" type="radio" name="provider" riot-value="{provider.id}"> <div class="flex-fixed w110 h60 mr12"><img class="s-full object-fit-contain" riot-src="/images/{provider.id}/{logoFileName(provider.id)}" alt="{provider.name}"></div> <div> <div class="ts-hxs text-gray_80 mb4">{provider.name}</div> <div class="ts-bpxs text-blue_60">{opts.amount.toLocaleString(\'ja-JP\') + getDisplayUnit(provider.id)}</div> </div> </div> </label> <div class="text-center ts-ps text-gray_80 mb20">一度ポイント種別を決めると後から変更できません</div> <button class="button size-l primary w-full mb12">選択したポイントを受け取る</button> <div class="ts-ps text-gray_60 text-center">受付終了日: {dayjs(opts.expiresAt).format(\'YYYY年M月D日 HH時mm分\')}</div> </form> </div>', '', '', function(opts) {
    this.filteredProviders = () => {
      return this.opts.providers.filter(provider => provider.id !== 'original_point');
    };

    this.logoFileName = (provider) => {
      const raster_logo_providers = ['apple_gift_card', 'google_play_gift_code'];

      return raster_logo_providers.includes(provider) ? 'logo.png' : 'logo.svg';
    };

    this.submit = (e) => {
      e.preventDefault();

      const submit_value = this.refs.form.provider.value;

      this.trigger('selectProvider', {
        value: submit_value
      });
    };

    this.getDisplayUnit = (provider) => {
      if (provider === 'ponta' || provider === 'point_at_gift' || provider === 'vpoint') {
        return 'ポイント'
      }
      else {
        return '円分'
      }
    };
});